const platformGuide = {
  platformGuide: {
    meta: {
      title: "Platform Guide",
      subtitle:
        "Learn how to use the platform, manage content, interact with others, and stay safe.",
      back: "Back",
      overviewTitle: "Help & Support",
      searchPlaceholder: "Search Platform Guide",
    },

    sidebar: {
      platformOverview: "Platform Overview",
      feeds: "Feeds & Activity",
      search: "Search",
      content: "Content & Posts",
      chat: "Chat",
      notification: "Notifications",
      myProfile: "MyProfile",
      safety: "Safety",
      troubleshooting: "Troubleshooting",
    },

    overview: {
      platformOverview: "Platform overview",

      feeds: "Feeds & Actiity",
      gallery: "Gallery",
      myFeed: "My Feed",
      myLikes: "My Likes",
      locationPosts: "Location Post Feed",
      musicPosts: "Music Post Feed",
      
      search: "Search",
      hiddenHashtags: "Hidden Hashtags",
      changeLocation: "Change location",
      currentLocation: "Current Location",

      content: "Content & Posts",
      uploadPost: "Upload post",
      musicInMedia: "Music in media",
      editPost: "Edit a post",
      deletePost: "Delete a post",
      postVisibility: "Post visibility",

      chat: "Chat",
      searchUsers: "Search Users to Chat",
      writeMessages: "Write Messages",
      deleteChat: "Delete an Active Chat",
      hideChat: "Hide an Active Chat",
      deleteMessage: "Delete a Message",
      replyMessage: "Reply to a Message",
      copyMessage: "Copy a Message",

      notification: "Notifications",
      chatNotification: "Chat Notifications",
      likeNotification: "Like Notifications",
      followNotification: "Follow Notifications",

      myProfile: "My Profile",
      myPosts: "My Posts",
      myFollowers: "My Followers",
      iFollow: "I Follow...",
      visitProfiles: "Visit other profiles",

      safety: "Safety",
      block: "Block a Profile",
      reportProfiles: "Block and Report Profiles",
      reportPosts: "Report Posts",

      troubleshooting: "Troubleshooting",
      loadingIssues: "Loading issues",
      uploadIssues: "Upload issues",
      notificationIssues: "Notification issues",
      messagesFail: "Messages not sent",
      contactPlatformSupport: "Contact platform support",
    },

  sections: {


//--------------------------------
//////Platform Overview///////
//--------------------------------

  platformOverview: {
  title: "Platform overview",
  body: [
    {
      type: "paragraph",
      text: "The platform allows you to discover location-based content, create and share posts, communicate with other users, manage your profile, and customize your experience through settings and privacy controls.",
    },
    {
      type: "bullets",
      items: [
        "Use Feeds & Activity to browse posts and review your activity.",
        "Use Change Location to discover posts from different locations.",
        "Use Search to find posts using hidden hashtags.",
        "Use Content & Posts to create, edit, manage, or remove your posts.",
        "Use Chat, Notifications, My Profile, Safety, and Troubleshooting to manage your account and interactions.",
      ],
    },
  ],
},

  //////////////////////////////////
  //////////Feeds & Activity////////
  /////////////////////////////////

feeds: {
  title: "Feeds & Activity",
  body: [
    {
      type: "paragraph",
      text: "Feeds & Activity is where you browse posts and access different content feeds.",
    },
    {
      type: "bullets",
      items: [
        "Use Gallery to discover posts from different locations.",
        "Use My Feed to view posts from profiles you follow.",
        "Use My Likes to revisit posts you have liked.",
        "Use Location Post Feed to view posts from the same location by selecting the location shown on a video/post.",
        "Use Music Post Feed to view posts using the same music track by selecting the music title shown on a video/post.",
      ],
    },
  ],
},

gallery: {
  title: "Gallery",
  body: [
    {
      type: "paragraph",
      text: "Gallery is the main feed of the platform where you discover posts from your current location or a selected location.",
    },
    {
      type: "bullets",
      items: [
        "Browse photos and videos shared by other users.",
        "Posts are organized using location-based feeds.",
        "Change location to discover content from other cities, countries, or regions.",
        "Like posts and connect with people through chat.",
      ],
    },
  ],
},

myFeed: {
  title: "My Feed",
  body: [
    {
      type: "paragraph",
      text: "My Feed displays posts from profiles you follow, helping you stay updated with people and content that interest you.",
    },
    {
      type: "bullets",
      items: [
        "View recent posts from followed profiles.",
        "Stay updated with users you follow.",
        "Unfollow profiles if you no longer wish to see their content.",
      ],
    },
  ],
},

  myLikes: {
    title: "My Likes",
    body: [
      {
        type: "paragraph",
        text: "My Likes helps you review posts you have liked on the platform.",
      },
      {
        type: "bullets",
        items: [
          "Review posts you previously liked.",
          "Unlike content if you change your mind.",
        ],
      },
    ],
  },

  locationPosts: {
  title: "Location Post Feed",
  body: [
    {
      type: "paragraph",
      text: "The Location Post Feed displays all available posts associated with a specific location. You can access it by selecting the location shown in any post.",
    },
    {
      type: "bullets",
      items: [
        "Select the location displayed in a post.",
        "View other posts from the same location.",
        "Change to another location by selecting a different location on another post.",
      ],
    },
  ],
},

musicPosts: {
  title: "Music Post Feed",
  body: [
    {
      type: "paragraph",
      text: "The Music Post Feed displays all available posts that use a specific music track. You can access it by selecting the music shown in a video/post.",
    },
    {
      type: "bullets",
      items: [
        "Select the music displayed in a video/post.",
        "View other videos/posts using the same music track.",
        "Discover content and profiles connected through the same music.",
        "Open any post to continue exploring content using that track.",
      ],
    },
  ],
},

///////////////////////////////////////
///////////Search///////////////////
//////////////////////////////////////

  search: {
  title: "Search",
  body: [
    {
      type: "paragraph",
      text: "Search helps you find posts associated with hidden hashtags.",
    },
    {
      type: "bullets",
      items: [
  "Search hidden hashtags to discover posts.",
  "Hidden hashtags can be added when creating or editing a post."
]
    },
  ],
},

hiddenHashtags: {
  title: "Hidden Hashtags",
  body: [
    {
      type: "paragraph",
      text: "Hidden Hashtags help organize content without displaying hashtags directly on posts. They can be added when creating a post and later used to discover related content through Search.",
    },
    {
      type: "bullets",
      items: [
        "Add hidden hashtags during post creation or later by editing your post.",
        "Hidden hashtags are not displayed publicly on posts.",
        "Use Search to find posts associated with a hidden hashtag.",
        "Hidden hashtags help categorize and organize content.",
      ],
    },
  ],
},

changeLocation: {
  title: "Change location",
  body: [
    {
      type: "paragraph",
      text: "Changing location lets you browse posts from another place without changing your account or profile location.",
    },
    {
      type: "bullets",
      items: [
        "Select Change Location to open the map.",
        "Choose a city or country, or select a place directly on the map.",
        "Confirm the location to view posts from that area.",
      ],
    },
    {
      type: "note",
      text: "Changing your browsing location does not change where your own posts are tagged.",
    },
  ],
},

 currentLocation: {
  title: "Current Location",
  body: [
    {
      type: "paragraph",
      text: "Current Location uses your detected location to show posts from the area around you.",
    },
    {
      type: "bullets",
      items: [
        "Enable location access if you want to use Current Location.",
        "Location access is required when creating a post so the post can be tagged with a location.",
        "Viewing posts with Current Location is optional. You can also choose any location using Change Location.",
      ],
    },
  ],
},

//////////////////////////////////////////////
//////////////Content & Posts///////////////////
////////////////////////////////////////////

  content: {
    title: "Content & Posts",
    body: [
      {
        type: "paragraph",
        text: "Content & Posts covers creating, editing, deleting, and controlling visibility for posts.",
      },
      {
        type: "bullets",
        items: [
          "Upload posts from the upload area.",
          "Edit or delete your own posts where available.",
          "Review post visibility so you understand where content can appear.",
        ],
      },
    ],
  },

uploadPost: {
title: "Upload post",
body: [
{
type: "paragraph",
text: "You can create and publish posts if your account is active.",
},
{
type: "steps",
items: [
"Open the Upload area.",
"Select the photos or video you want to publish.",
"Each post can contain up to 8 media files, including a maximum of 1 video.",
"Add hidden hashtags to help categorize your post (optional).",
"Select music for a video (optional).",
"Confirm the location of the post.",
"Review your post and select Upload.",
],
},
{
type: "note",
text: "Only upload content that you own or have permission to use and that follows platform rules.",
},
],
},


 musicInMedia: {
title: "Music in video",
body: [
{
type: "paragraph",
text: "Music can be added to a video during the post creation process.",
},
{
type: "bullets",
items: [
"You can select music when adding a video post.",
"Other users can open the music title to view posts using the same track.",
"Use music provided by Elnydo music choice or music already in the video you have permission to use.",
],
},
],
},


 editPost: {
title: "Edit a post",
body: [
{
type: "paragraph",
text: "You can edit certain information on your own posts after publishing.",
},
{
type: "steps",
items: [
"Open My Posts in My Profile sidebar.",
"Select the post you want to edit.",
"You can delete media or add hidden hashtags to the post.",
"Save your changes.",
],
},
{
type: "note",
text: "Uploaded media files themselves cannot be changed after publishing.",
},
],
},


  deletePost: {
    title: "Delete a post",
    body: [
      {
        type: "paragraph",
        text: "Deleting a post removes it from your profile and from public platform areas where it appears.",
      },
      {
        type: "steps",
        items: [
          "Open your profile or post management area.",
          "Select the post you want to remove.",
          "Open the post options.",
          "Choose Delete.",
          "Confirm the deletion.",
        ],
      },
      {
        type: "note",
        text: "Deleted posts may not be recoverable.",
      },
    ],
  },

 postVisibility: {
title: "Post visibility",
body: [
{
type: "paragraph",
text: "Post visibility allows you to control whether your posts are visible to other users.",
},
{
type: "bullets",
items: [
"Visible posts may appear in Gallery, My Feed, Location Post Feeds, Music Post Feeds, and on your profile.",
"You can hide a post without deleting it.",
"Hidden posts are removed from public view",
"You can make a hidden post visible again later.",
"Deleting a post permanently removes it from the platform.",
],
},
],
},


/////////////////////////////////////////
////////////////Chat///////////////////
////////////////////////////////////////

  chat: {
    title: "Chat",
    body: [
      {
        type: "paragraph",
        text: "Chat allows you to communicate with other users where messaging is available.",
      },
      {
        type: "bullets",
        items: [
          "Search for users to start a conversation.",
          "Write, reply to, copy, and delete messages.",
          "Hide or delete active chats if you no longer want them visible.",
        ],
      },
    ],
  },

  searchUsers: {
    title: "Search Users to Chat",
    body: [
      {
        type: "paragraph",
        text: "Search Users to Chat helps you find a profile and start a conversation.",
      },
      {
        type: "bullets",
        items: [
          "Open the chat or message area.",
          "Search for the user you want to contact.",
          "Open the user's profile and start a chat.",
        ],
      },
    ],
  },

  writeMessages: {
    title: "Write Messages",
    body: [
      {
        type: "paragraph",
        text: "Writing messages lets you communicate directly with another user.",
      },
      {
        type: "bullets",
        items: [
          "Open an existing chat or start a new one.",
          "Type your message in the message field.",
          "Send the message and wait for it to appear in the conversation.",
        ],
      },
      {
        type: "note",
        text: "Avoid sharing passwords, private codes, or sensitive personal information in chat.",
      },
    ],
  },

  deleteChat: {
    title: "Delete an Active Chat",
    body: [
      {
        type: "paragraph",
        text: "Deleting an active chat removes the conversation from your chat list without affecting the other participant's chat.",
      },
      {
        type: "steps",
        items: [
          "Open the chat list.",
          "Select the active chat you want to delete.",
          "Open the chat options.",
          "Choose Delete chat and confirm the action.",
        ],
      },
    ],
  },

hideChat: {
  title: "Hide an Active Chat",
  body: [
    {
      type: "paragraph",
      text: "Hiding a chat removes it from your visible chat list without deleting the conversation.",
    },
    {
      type: "bullets",
      items: [
        "Open the chat list.",
        "Select the chat you want to hide.",
        "Choose Hide Chat.",
        "The chat may reappear if new messages are received.",
      ],
    },
  ],
},

deleteMessage: {
  title: "Delete a Message",
  body: [
    {
      type: "paragraph",
      text: "Deleting a message removes it from the conversation.",
    },
    {
      type: "steps",
      items: [
        "Open the chat containing the message.",
        "Select the message options.",
        "Choose Delete Message.",
        "Confirm the deletion.",
      ],
    },
    {
      type: "note",
      text: "Messages deleted by the sender are removed from the conversation for all participants.",
    },
  ],
},

  replyMessage: {
    title: "Reply to a Message",
    body: [
      {
        type: "paragraph",
        text: "Replying to a message lets you answer a specific message inside a conversation.",
      },
      {
        type: "bullets",
        items: [
          "Open the conversation.",
          "Choose the message you want to reply to.",
          "Write your reply and send it.",
        ],
      },
    ],
  },

  copyMessage: {
    title: "Copy a Message",
    body: [
      {
        type: "paragraph",
        text: "Copying a message lets you copy message text so you can reuse or save it outside the chat.",
      },
      {
        type: "bullets",
        items: [
          "Open the message options.",
          "Choose Copy message where available.",
          "Paste the copied text where you need it.",
        ],
      },
    ],
  },


//////////////////////////////////////
///////////Notification//////////////
/////////////////////////////////////

  notification: {
    title: "Notifications",
    body: [
      {
        type: "paragraph",
        text: "Notifications inform you about important activity such as chat messages, likes and people following you.",
      },
      {
        type: "bullets",
        items: [
          "Check notification settings in your account.",
          "Make sure browser or device notifications are allowed.",
          "Review chat, like, and follow notifications separately where available.",
        ],
      },
    ],
  },

  chatNotification: {
    title: "Chat Notifications",
    body: [
      {
        type: "paragraph",
        text: "Chat notifications let you know when new messages or chat activity are available.",
      },
      {
        type: "bullets",
        items: [
          "Allow notifications in your browser or device.",
          "Check that chat notifications are enabled in platform settings.",
          "Open the chat from the notification if you want to reply.",
        ],
      },
    ],
  },

  likeNotification: {
    title: "Like Notifications",
    body: [
      {
        type: "paragraph",
        text: "Like notifications tell you when another user likes your post or content where this feature is available.",
      },
      {
        type: "bullets",
        items: [
          "Open the notification area to review likes.",
          "Open the related post to see more details.",
          "Adjust notification preferences if you do not want like notifications.",
        ],
      },
    ],
  },

  followNotification: {
    title: "Follow Notifications",
    body: [
      {
        type: "paragraph",
        text: "Follow notifications tell you when another user follows your profile.",
      },
      {
        type: "bullets",
        items: [
          "Open the notification to view the follower profile.",
          "Review your followers list from your profile where available.",
          "Adjust notification preferences if you do not want follow notifications.",
        ],
      },
    ],
  },


///////////////////////////////////////
///////////My Profile//////////////////
//////////////////////////////////////

  myProfile: {
    title: "My Profile",
    body: [
      {
        type: "paragraph",
        text: "Your profile is where other users can see your public profile information and your available posts.",
      },
      {
        type: "bullets",
        items: [
          "Review your profile name and profile picture.",
          "Check your posts and profile activity.",
          "Adjust your profile information from account settings if available.",
        ],
      },
    ],
  },

  myPosts: {
    title: "My Posts",
    body: [
      {
        type: "paragraph",
        text: "My Posts shows the content you have published on the platform.",
      },
      {
        type: "bullets",
        items: [
          "View your published posts.",
          "Open individual posts for details.",
          "Edit or delete posts if these actions are available.",
        ],
      },
    ],
  },

  myFollowers: {
    title: "My Followers",
    body: [
      {
        type: "paragraph",
        text: "My Followers shows users who follow your profile where this feature is available.",
      },
      {
        type: "bullets",
        items: [
          "Open your profile follower area.",
          "Review the list of followers.",
          "Open a follower profile to view public information or interaction options.",
        ],
      },
    ],
  },

  iFollow: {
    title: "I Follow...",
    body: [
      {
        type: "paragraph",
        text: "I Follow shows profiles you follow on the platform.",
      },
      {
        type: "bullets",
        items: [
          "Open your following list from your profile area.",
          "Review profiles you currently follow.",
          "Unfollow a profile if you no longer want to follow it.",
        ],
      },
    ],
  },

  visitProfiles: {
    title: "Visit other profiles",
    body: [
      {
        type: "paragraph",
        text: "You can visit other profiles to view public profile information, posts, and available interaction options.",
      },
      {
        type: "bullets",
        items: [
          "Open a user’s profile from a post, search result, or follower list.",
          "Follow, message, block, or report users where available.",
          "Respect privacy and community rules when interacting.",
        ],
      },
    ],
  },

//////////////////////////////////////////////////
///////////////Safety////////////////////////////
/////////////////////////////////////////////////

  safety: {
    title: "Safety",
    body: [
      {
        type: "paragraph",
        text: "Safety features help keep the platform respectful and secure for users.",
      },
      {
        type: "bullets",
        items: [
          "Block profiles when you want to stop unwanted interaction.",
          "Report profiles or posts that may violate platform rules.",
          "Use privacy and safety options carefully when interacting with others.",
        ],
      },
    ],
  },

  block: {
    title: "Block a Profile",
    body: [
      {
        type: "paragraph",
        text: "Blocking another profile helps stop unwanted interaction from that user where blocking is supported.",
      },
      {
        type: "bullets",
        items: [
          "Open the profile you want to block.",
          "Open the profile options.",
          "Choose Block and confirm the action.",
        ],
      },
    ],
  },

  reportProfiles: {
    title: "Block and Report Profiles",
    body: [
      {
        type: "paragraph",
        text: "Blocking & Reporting a profile helps the platform review behavior that may break platform rules.",
      },
      {
        type: "bullets",
        items: [
          "Open the profile you want to report.",
          "Choose the report or block/report option.",
          "Provide clear information and submit the report.",
        ],
      },
    ],
  },

  reportPosts: {
    title: "Report Posts",
    body: [
      {
        type: "paragraph",
        text: "Reporting posts helps the platform review content that may be harmful, illegal, misleading, or against platform rules.",
      },
      {
        type: "bullets",
        items: [
          "Open the post you want to report.",
          "Open the post options and choose Report.",
          "Select a reason and add details if requested.",
        ],
      },
    ],
  },


///////////////////////////////////////////////
////////////Troubleshooting///////////////////
///////////////////////////////////////////////

  troubleshooting: {
    title: "Troubleshooting",
    body: [
      {
        type: "paragraph",
        text: "Troubleshooting helps you solve common issues with loading, uploads, notifications, messages, and support contact.",
      },
      {
        type: "bullets",
        items: [
          "Refresh the page and check your internet connection first.",
          "Review the specific issue section for upload, notification, or message problems.",
          "Contact support if the issue continues.",
        ],
      },
    ],
  },

  loadingIssues: {
    title: "Loading issues",
    body: [
      {
        type: "paragraph",
        text: "Loading issues can happen because of connection problems, browser cache, server issues, or device performance.",
      },
      {
        type: "bullets",
        items: [
          "Refresh the page.",
          "Check your internet connection.",
          "Try another browser or a private window.",
          "Clear cache if the issue continues.",
        ],
      },
    ],
  },

  uploadIssues: {
    title: "Upload issues",
    body: [
      {
        type: "paragraph",
        text: "Upload problems can occur if the file is too large, the format is unsupported, or the connection is unstable.",
      },
      {
        type: "bullets",
        items: [
          "Check file type and file size.",
          "Use a stable internet connection.",
          "Try uploading again.",
          "Contact support if the problem continues.",
        ],
      },
    ],
  },

  notificationIssues: {
    title: "Notification issues",
    body: [
      {
        type: "paragraph",
        text: "If notifications are not working, check both platform settings and your browser or device permissions.",
      },
      {
        type: "bullets",
        items: [
          "Enable notifications in platform settings.",
          "Allow notifications in your browser or device.",
          "Check Do Not Disturb or focus modes.",
          "Sign out and sign in again if necessary.",
        ],
      },
    ],
  },

  messagesFail: {
    title: "Messages not sent",
    body: [
      {
        type: "paragraph",
        text: "Messages may fail to send because of connection problems, account restrictions, blocked users, or temporary platform issues.",
      },
      {
        type: "bullets",
        items: [
          "Check your internet connection.",
          "Try sending the message again after a moment.",
          "Make sure the chat is still available and the user can receive messages.",
          "Contact support if messages continue to fail.",
        ],
      },
    ],
  },

  contactPlatformSupport: {
    title: "Contact platform support",
    body: [
      {
        type: "paragraph",
        text: "Contact support if you cannot solve a platform issue yourself.",
      },
      {
        type: "bullets",
        items: [
          "Describe the issue clearly.",
          "Mention when the problem started.",
          "Include screenshots if useful.",
          "Never include passwords or private verification codes.",
        ],
      },
    ],
  },
},

  },
} as const;

export default platformGuide;